"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PasscodeCompleteStatus = void 0;
var React = require("react");
var PasscodeState_1 = require("./PasscodeState");
/** Platform Ui Components */
var GridRow_1 = require("@idp/ui-components/components/containers/Grid/GridRow");
var GridColumn_1 = require("@idp/ui-components/components/containers/Grid/GridColumn");
var TextField_1 = require("@idp/duc/components/atoms/TextField");
var TextFieldProps_1 = require("@idp/duc/components/atoms/TextField/TextFieldProps");
var Link_1 = require("@idp/duc/components/atoms/Link");
var Tooltip_1 = require("@idp/duc/components/atoms/Tooltip");
var IconSvg_1 = require("@idp/duc/components/atoms/IconSvg");
var Checkbox_1 = require("@idp/duc/components/atoms/Checkbox");
/** CMS */
var cms_integration_1 = require("@idp/cms-integration");
// import { PasscodeCms } from './Passcode.cms';
// import { InlineErrorsCms } from '../../common/CommonFunctions/InlineErrors.cms';
/** Stylesheets */
var utilityStyles = require("../../../styles/utilities.scss");
var appStyles = require("../../../styles/login-widget.scss");
var styles = require("./Passcode.scss");
/** LOB Components */
var PageLevelHeading_1 = require("../../common/PageLevelHeading");
var PageLevelHeadingProps_1 = require("../../common/PageLevelHeading/PageLevelHeadingProps");
var PageLevelMessage_1 = require("../../common/PageLevelMessage");
var PageLevelMessageProps_1 = require("../../common/PageLevelMessage/PageLevelMessageProps");
var CtaButtonGroup_1 = require("../../common/CtaButtonGroup");
var CtaButtonGroupProps_1 = require("../../common/CtaButtonGroup/CtaButtonGroupProps");
var SMBAccountModal_1 = require("./SMBAccountModal/SMBAccountModal");
/** Api, Reporting, Mappers, Request, Response */
var analytics_1 = require("@login/analytics");
var Events_1 = require("../../../api/Events");
var ReportingService_1 = require("../../../api/ReportingService");
var StateProvider_1 = require("../../../api/StateProvider");
var ValidatePasscodeRequestV2_1 = require("../../../models/request/ValidatePasscodeRequestV2");
var LoginApi_1 = require("../../../api/LoginApi");
var FeatureToggleService_1 = require("../../../services/FeatureToggleService");
// import { PasscodeAccount } from '../../../models/response/PasscodeAccount';
var CommonFunctions_1 = require("../../common/CommonFunctions/CommonFunctions");
var PasscodeCompleteStatus;
(function (PasscodeCompleteStatus) {
    PasscodeCompleteStatus[PasscodeCompleteStatus["ACCOUNT_SELECTION"] = 0] = "ACCOUNT_SELECTION";
    PasscodeCompleteStatus[PasscodeCompleteStatus["SUCCESS"] = 1] = "SUCCESS";
})(PasscodeCompleteStatus = exports.PasscodeCompleteStatus || (exports.PasscodeCompleteStatus = {}));
var PasscodeV2 = /** @class */ (function (_super) {
    __extends(PasscodeV2, _super);
    function PasscodeV2(props) {
        var _this = _super.call(this, props) || this;
        _this.loginSuccessEvent = 'loginSuccessEvent';
        _this.forgotPasscodeStageUrl = 'https://dssqa6-m.stage.att.com/my/#/passthrough/forgotPasscode?originationPoint=idplgn';
        _this.forgotPasscodeProdUrl = 'https://m.att.com/my/#/passthrough/forgotPasscode?originationPoint=idplgn';
        _this.errorMap = new Map();
        _this.mapExtraSecurityCheckBox = new Map();
        _this.skipPasscodeCheckBoxMap = new Map();
        _this.passcodevalue2 = new Map();
        /*  disableExtraSecurity = new Map<number, boolean>();
          disableTextFiled = new Map<number, boolean>();
          */
        _this.loginApi = new LoginApi_1.default();
        _this.idNumberPattern = /^\d+$/g;
        _this.PASSCODE_VALIDATION = true;
        _this.PASSCODE_SUBMIT = 'myATT_LGN_Passcode_Submit';
        _this.idpForgotPasscodePath = '/acctmgmt/passthrough/FORGOTPASSCODE?last4Ban=';
        _this.commonFunctions = null;
        _this.extraSecurityFlag = true;
        _this.state = new PasscodeState_1.default();
        // this.submitPasscode = this.submitPasscode.bind(this);
        _this.reportingService = new ReportingService_1.default();
        _this.stateManager = StateProvider_1.StateProvider.getStateManagerInstance();
        _this.commonFunctions = CommonFunctions_1.CommonFunctions.getInstance();
        // this.linkForgotPasscodeEvent = this.linkForgotPasscodeEvent.bind(this);
        _this.linkSecurityPasscodeEvent = _this.linkSecurityPasscodeEvent.bind(_this);
        _this.linkAccountSelectionEvent = _this.linkAccountSelectionEvent.bind(_this);
        _this.continueBtnEvents = _this.continueBtnEvents.bind(_this);
        _this.cancelBtnEvents = _this.cancelBtnEvents.bind(_this);
        _this.submitPasscodeV2 = _this.submitPasscodeV2.bind(_this);
        _this.initializeEvents();
        return _this;
    }
    PasscodeV2.prototype.componentDidMount = function () {
        this.setState({
            currentAccountList: this.props.data.accountList,
        });
        this.events = new Events_1.default([PasscodeV2.passcodeSuccessEventName, this.loginSuccessEvent]);
        // console.log( 'Passcode - ', this.props.data );
        if (this.props.options !== null &&
            this.props.options !== undefined &&
            this.props.options.pageLoadEvent !== null &&
            this.props.options.pageLoadEvent !== undefined &&
            this.props.options.pageLoadEvent) {
            this.analyticsPasscodeFormPageLoad();
        }
        // this.analyticsPasscodeFormPageLoad();
    };
    PasscodeV2.prototype.analyticsPasscodeFormPageLoad = function () {
        // this.reportingService.firePageLoadEvent('/login/authentication');
        this.reportingService
            .analyticsLoginPageLoad('isPasscodePageLoadedAlready', ReportingService_1.PageUrls.PASSCODE_PAGE, ReportingService_1.PageName.PASSCODE_PAGE);
    };
    PasscodeV2.prototype.initializeEvents = function () {
        var _this = this;
        // this.PasscodeCmsData = CMS.get(new PasscodeCms(), 'Passcode').content;
        // this.InlineErrorsCmsData = CMS.get(new InlineErrorsCms(), 'InlineErrors').content;
        this.PasscodeCmsData = cms_integration_1.CMS.get({}, 'login').content.loginConsole;
        this.modalEvents = {
            modalClosed: function () {
                _this.setState({
                    showModal: false,
                });
            },
        };
    };
    PasscodeV2.prototype.linkSecurityPasscodeEvent = function () {
        this.analyticsPasscodeFormPageLoad();
        var linkSecurityPasscode = 'https://www.att.com/esupport/article.html#!/wireless/KM1049472';
        this.reportingService.fireLinkClickEvent(ReportingService_1.LoginLinkNames.SECURITY_PASSCODE, linkSecurityPasscode);
        // window.location.href = linkSecurityPasscode;
        window.open(linkSecurityPasscode);
    };
    PasscodeV2.prototype.linkAccountSelectionEvent = function () {
        this.analyticsPasscodeFormPageLoad();
        console.log('linkAccountSelectionEvent');
        var linkSecurityPasscode = ReportingService_1.PageUrls.ACCOUNT_SELECTION;
        this.reportingService.fireLinkClickEvent(ReportingService_1.LoginLinkNames.ACCOUNT_SELECTION, linkSecurityPasscode);
        this.fireComplete(PasscodeCompleteStatus.ACCOUNT_SELECTION);
    };
    PasscodeV2.prototype.continueBtnEvents = function () {
        console.log('Passcode continueClickEvent V2', this.state.passcodeValue);
        // if (!this.state.processing) {
        this.submitPasscodeV2();
        // }
    };
    PasscodeV2.prototype.cancelBtnEvents = function () {
        var _this = this;
        var loginUrl;
        if (this.props.data && this.props.data.loginUrl) {
            loginUrl = this.props.data.loginUrl;
        }
        else {
            loginUrl = document.location.href;
        }
        this.reportingService.fireLinkClickEvent(ReportingService_1.LoginLinkNames.CANCEL, loginUrl);
        // we do the session invalidate if the skipInvalidateOnCancel option
        // is not set or is false
        // and is if the channel is not sales
        var doInvalidate = !(this.props.options && this.props.options.skipInvalidateOnCancel)
            && this.props.data.channel !== 'sales';
        if (doInvalidate) {
            this.loginApi.invalidateSession().then(function () {
                _this.events.fireEvent({
                    authenticated: false,
                    cancelled: true,
                    errorMessage: _this.state.passcodeErrorMessage,
                    errorId: _this.state.passcodeErrorId,
                }, _this.loginSuccessEvent);
            });
        }
        else {
            this.events.fireEvent({
                authenticated: false,
                cancelled: true,
                errorMessage: this.state.passcodeErrorMessage,
                errorId: this.state.passcodeErrorId,
            }, this.loginSuccessEvent);
        }
    };
    PasscodeV2.prototype.fireComplete = function (status) {
        console.log('Passcode fireComplete');
        var data = {
            status: status,
        };
        this.events.fireEvent(data, PasscodeV2.passcodeSuccessEventName);
    };
    PasscodeV2.prototype.submitPasscodeV2 = function () {
        return __awaiter(this, void 0, void 0, function () {
            var result, request, currentAccountList, remianedAccountList, disableTextFiled_1, disableExtraSecurity_1, remianedAccounts, exc_1;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.analyticsPasscodeFormPageLoad();
                        console.log('submitPasscode passcodeAccountsList =', this.state.passcodeAccountsList);
                        this.setState({
                            processing: true,
                        });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        request = void 0;
                        currentAccountList = this.state.currentAccountList;
                        remianedAccountList = [];
                        disableTextFiled_1 = this.state.disableTextFiled;
                        disableExtraSecurity_1 = this.state.disableExtraSecurity;
                        request = new ValidatePasscodeRequestV2_1.ValidatePasscodeRequestV2(this.state.passcodeAccountsList);
                        console.log('ValidatePasscode request 55 : ', JSON.stringify(request));
                        return [4 /*yield*/, this.loginApi.validatePasscodeV2(this.state.passcodeAccountsList)];
                    case 2:
                        result = _a.sent();
                        console.log('ValidatePasscode result:', JSON.stringify(result));
                        this.sucessASM = [];
                        this.errorASM = [];
                        this.serviceErrorMessage = [];
                        this.combineErrorMessage = '';
                        this.serviceErrorID = [];
                        // If we have a error api call, throw it to let the catch block below render it.
                        if (result.error) {
                            throw result.error;
                        }
                        result.content.validatePasscodeInfos.map(function (response, i) {
                            if (response.success) {
                                _this.sucessASM[i] = response.selectedASMIndex;
                            }
                            else {
                                _this.errorASM[i] = response.selectedASMIndex;
                                /* accumulating nonblank the backend error message for PageLevel Error*/
                                if (null !== response.serviceError.message) {
                                    _this.serviceErrorMessage[i] = response.serviceError.message;
                                    _this.combineErrorMessage += response.serviceError.message + '\n \n \b';
                                }
                                console.log('response.serviceError.message = ', _this.combineErrorMessage);
                                _this.serviceErrorID[i] = response.serviceError.errorId;
                            }
                        });
                        console.log('passcodeAccountsListState 5 = ', remianedAccountList);
                        console.log('serviceErrorMessage = ', JSON.stringify(this.serviceErrorMessage));
                        if (this.commonFunctions.notBlankCheck(this.combineErrorMessage)) {
                            /**
                             * filter out the list of Account
                             * not validated yet and ASM returned in response.
                             * Need them to rerender those account.
                             */
                            console.log('remianAccountList Error = ', remianedAccountList);
                            remianedAccountList =
                                currentAccountList.filter(function (account) {
                                    console.log('response selectedASMIndex ', account);
                                    if (_this.errorASM.indexOf(account.asmIndex) > -1) {
                                        _this.passcodevalue2.set(account.asmIndex, '');
                                        if (_this.skipPasscodeCheckBoxMap.get(account.asmIndex)) {
                                            _this.skipPasscodeCheckBoxMap.set(account.asmIndex, false);
                                        }
                                        disableExtraSecurity_1.set(account.asmIndex, true);
                                        disableTextFiled_1.set(account.asmIndex, false);
                                        return true;
                                    }
                                });
                            console.log('this.serviceErrorMessage[1] Error= ', JSON.stringify(this.serviceErrorMessage));
                            if (this.serviceErrorID.indexOf('MS_PRF_VAP_BE_05') > -1) {
                                this.combineErrorMessage = this.PasscodeCmsData.error.passcodeAccountLockText;
                            }
                            else {
                                this.combineErrorMessage = this.PasscodeCmsData.error.invalidPasscodeAccountText;
                            }
                            remianedAccounts = remianedAccountList.map(function (account, i) {
                                account.passcode = '';
                            });
                            this.setState({
                                errorMessage: this.combineErrorMessage,
                                // errorMessageV2: this.serviceErrorMessage,
                                errorIdV2: this.serviceErrorID,
                                processing: false,
                                disabledButton: true,
                                currentAccountList: remianedAccountList,
                                disableTextFiled: disableTextFiled_1,
                                disableExtraSecurity: disableExtraSecurity_1,
                            });
                            return [2 /*return*/];
                        }
                        else {
                            this.setState({
                                processing: false,
                                passcodeErrorMessage: null,
                                passcodeErrorId: null,
                            });
                            this.reportingService.genericFireFormResponseEvent(false, 'success', '0', analytics_1.ErrorTypeOption.Success_Admit, 'Continue', this.PASSCODE_SUBMIT, ReportingService_1.PageUrls.PASSCODE_PAGE);
                            /*firing success event when all passcode successfully validated**/
                            this.fireComplete(PasscodeCompleteStatus.SUCCESS);
                            /* if ( this.sucessASM.length > 0 ) {
                                 console.log('passcodeAccountsListState 6 = ',
                                 this.sucessASM);
                             } else {
                                 console.log('firing success event no passcode Account left to validate ',
                                 this.sucessASM);
                                 this.fireComplete( PasscodeCompleteStatus.SUCCESS );
                             }*/
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        exc_1 = _a.sent();
                        this.reportingService.genericFireFormResponseEvent(true, exc_1.message, exc_1.message, analytics_1.ErrorTypeOption.Failure_System, 'Continue', this.PASSCODE_SUBMIT, ReportingService_1.PageUrls.PASSCODE_PAGE);
                        this.setState({
                            processing: false,
                            errorMessage: 'Something isn\'t working quite right. Please try again.',
                            passcodeErrorMessage: exc_1.message,
                            passcodeErrorId: exc_1.errorId,
                        });
                        console.error('error on ValidatePasscode call', exc_1);
                        return [2 /*return*/];
                    case 4:
                        this.setState({
                            disabledButton: false,
                            processing: false,
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    PasscodeV2.prototype.validatePasscodeOnBlur = function (value) {
        console.log('Passcode Value', value);
        var passcodeErrTxt = '';
        if (this.commonFunctions.notBlankCheck(value)) {
            var passedValue = (value ? value.replace(/[^a-zA-Z0-9@_+-]/g, '') : '');
            var numberPatternCheck = passedValue.match(this.idNumberPattern);
            if (value.length < 4 || value.length > 8) {
                console.log('Passcode Value less than 4 digit or greater than 8 digit !!');
                this.setState({
                    isPasscodeinValid: true,
                    passcodeErrTxt: this.PasscodeCmsData.error.blankPasscodeText,
                });
                passcodeErrTxt = this.PasscodeCmsData.error.blankPasscodeText;
            }
            else if (!numberPatternCheck) {
                console.log('not in number format!!');
                this.setState({
                    isPasscodeinValid: true,
                    passcodeErrTxt: this.PasscodeCmsData.error.invalidPasscodeText,
                });
                passcodeErrTxt = this.PasscodeCmsData.error.invalidPasscodeText;
            }
            else {
                this.setState({
                    isPasscodeinValid: false,
                    passcodeErrTxt: '',
                });
            }
        }
        else {
            console.log('Passcode Value is undefined');
            this.setState({
                isPasscodeinValid: true,
                passcodeErrTxt: this.PasscodeCmsData.error.blankPasscodeText,
            });
            passcodeErrTxt = this.PasscodeCmsData.error.blankPasscodeText;
        }
        return passcodeErrTxt;
    };
    PasscodeV2.prototype.enableContinueButton = function (asmAccountList) {
        var _this = this;
        this.continueflag = [];
        var passcodeAccountsize = asmAccountList.length;
        var passcodeAccountsList = this.state.passcodeAccountsList;
        asmAccountList.map(function (account, i) {
            if (_this.commonFunctions.notBlankCheck(_this.passcodevalue2.get(account.asmIndex)) &&
                _this.commonFunctions.blankCheck(_this.errorMap.get(account.asmIndex))) {
                _this.continueflag[i] = true;
            }
            else if (_this.skipPasscodeCheckBoxMap.get(account.asmIndex)) {
                _this.continueflag[i] = true;
            }
            else {
                _this.continueflag[i] = false;
            }
        });
        // console.log( 'continueflag ' + JSON.stringify( this.continueflag ) );
        if (this.continueflag.indexOf(false) > -1) {
            console.log('disable continueflag ' + JSON.stringify(this.continueflag));
            this.setState({ disabledButton: true });
            // Returns false - continue is disabled
            return false;
        }
        else {
            console.log('enable continueflag ' + JSON.stringify(this.continueflag));
            this.setState({ disabledButton: false });
            // Return true - continue is enabled
            return true;
        }
    };
    PasscodeV2.prototype.render = function () {
        var _this = this;
        var loginPasscodeTestId = 'Login_Passcode';
        var listItems = this.state.currentAccountList.map(function (account, i) {
            var passcodeEventsV2 = {
                onChange: function (event) {
                    // console.log( `onChange ${i}`, event.target.value );
                    _this.passcodevalue2.set(account.asmIndex, event.target.value);
                    var disableExtraSecurity = new Map(_this.state.disableExtraSecurity);
                    disableExtraSecurity.set(account.asmIndex, _this.commonFunctions.blankCheck(event.target.value));
                    _this.setState({ disableExtraSecurity: disableExtraSecurity });
                    // console.log( 'passwordField, onChange', event.currentTarget.value );
                    _this.errorMap.set(account.asmIndex, '');
                    _this.enableContinueButton(_this.props.data.accountList);
                },
                /* On Clear doesn't show on password type fields */
                // onClear: () => {
                //     this.passcodevalue2.set( account.asmIndex, '' );
                //     const disableExtraSecurity = new Map( this.state.disableExtraSecurity );
                //     disableExtraSecurity.set( account.asmIndex, true );
                //     this.setState( { disableExtraSecurity } );
                //     this.enableContinueButton( this.props.data.accountList );
                // },
                onBlur: function (passcodeValue) {
                    console.log('i= ', i);
                    _this.analyticsPasscodeFormPageLoad();
                    var errorText = _this.validatePasscodeOnBlur(passcodeValue);
                    _this.errorMap.set(account.asmIndex, errorText);
                    console.log('onBlur -> errorText, errorMap = ', errorText, _this.errorMap);
                    var extraSecurityOffFlag = _this.mapExtraSecurityCheckBox.get(account.asmIndex);
                    var detailList = {
                        selectedASMIndex: account.asmIndex,
                        accountType: account.accountType,
                        passcode: passcodeValue,
                    };
                    if (extraSecurityOffFlag) {
                        detailList.extraSecurityOff = extraSecurityOffFlag;
                    }
                    _this.passcodevalue2.set(account.asmIndex, passcodeValue);
                    // Do not enable these outside a local environment
                    // console.log('passcodeValue = ' + this.passcodevalue2.get(account.asmIndex));
                    // console.log('detailList = ' + JSON.stringify(detailList));
                    var passcodeAccountsListState = _this.state.passcodeAccountsList.filter(function (passcodeAccount) {
                        return (passcodeAccount.selectedASMIndex !== account.asmIndex);
                    });
                    var disableExtraSecurity = new Map(_this.state.disableExtraSecurity);
                    // console.log('disableExtraSecurity 1 = ', disableExtraSecurity);
                    // console.log('passcodeAccountsListState 1 = ', + JSON.stringify(passcodeAccountsListState));
                    // console.log('detailList', detailList);
                    if (_this.commonFunctions.notBlankCheck(detailList.passcode)) {
                        if (_this.commonFunctions.blankCheck(errorText)) {
                            passcodeAccountsListState.push(detailList);
                        }
                        console.log('passcode is not null');
                        disableExtraSecurity.set(account.asmIndex, false);
                    }
                    // console.log('disableExtraSecurity 2 = ', disableExtraSecurity);
                    // console.log('passcodeAccountsListState 2 = ' + JSON.stringify(passcodeAccountsListState));
                    _this.setState({
                        passcodeAccountsList: passcodeAccountsListState,
                        disableExtraSecurity: disableExtraSecurity,
                    }, function () {
                        console.log('passcodeAccountsListState 3 = ' +
                            JSON.stringify(_this.state.passcodeAccountsList));
                        _this.enableContinueButton(_this.props.data.accountList);
                    });
                },
            };
            if (_this.state.currentAccountList.length === 1) {
                // If the currentAccountList is length 1 and an Enter key is detected
                // Submit the form
                passcodeEventsV2.onKeyPress = function (oldValue, e) {
                    if (e.key === 'Enter') {
                        // Trigger blur to field validate
                        passcodeEventsV2.onBlur(_this.passcodevalue2.get(account.asmIndex));
                        // If continue is enabled, submit
                        if (_this.enableContinueButton(_this.props.data.accountList)) {
                            // This set state is purely to make sure all previous set states
                            // have run prior to calling continueBtnEvents, otherwise
                            // the data isn't in sync
                            _this.setState({}, function () {
                                _this.continueBtnEvents();
                            });
                        }
                    }
                };
            }
            var getServerOrigin = function () {
                var port = window.location.port ? ':' + window.location.port : '';
                var host = window.location.hostname + port;
                var origin = window.location.protocol + '//' + host;
                return origin;
            };
            var linkForgotPasscodeEvent = function () { return __awaiter(_this, void 0, void 0, function () {
                var forgotPasscodeUrl, url, toggleName, useIdpForgotPasscode, last4Ban;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // SMB condition to show modal
                            console.log('account.smbCustomer =' + account.smbCustomer);
                            if (!(account.smbCustomer || account.accountType === 'WIRELINE')) return [3 /*break*/, 1];
                            // this.showSMBModalMap.set(account.asmIndex, account.smbCustomer);
                            this.setState({
                                showModal: true,
                                wirelineModal: account.accountType === 'WIRELINE',
                            });
                            return [3 /*break*/, 3];
                        case 1:
                            this.analyticsPasscodeFormPageLoad();
                            forgotPasscodeUrl = '';
                            url = document.location.href;
                            toggleName = 'svc-login-use-idp-forgot-passcode';
                            return [4 /*yield*/, FeatureToggleService_1.default.checkFeatureToggleEnabled(toggleName)];
                        case 2:
                            useIdpForgotPasscode = _a.sent();
                            if (useIdpForgotPasscode) {
                                last4Ban = account.maskedBan.slice(-4);
                                forgotPasscodeUrl = getServerOrigin() + this.idpForgotPasscodePath + last4Ban;
                            }
                            else {
                                if (url.indexOf('stage.att.com') > -1 ||
                                    url.indexOf('dev.att.com') > -1) {
                                    forgotPasscodeUrl = this.forgotPasscodeStageUrl + '&cancelUrl=' + this.props.data.returnUrl
                                        + '&returnUrl=' + this.props.data.returnUrl;
                                }
                                else {
                                    forgotPasscodeUrl = this.forgotPasscodeProdUrl + '&cancelUrl=' + this.props.data.returnUrl
                                        + '&returnUrl=' + this.props.data.returnUrl;
                                }
                            }
                            /* const forgotPasscode = 'https://www.att.com/my/#/forgotPasscode?' +
                                    'OriginationPoint=login&cancelUrl=' + this.props.data.returnUrl +
                                    '&returnUrl=' + this.props.data.returnUrl;
                            */
                            this.reportingService.fireLinkClickEvent(ReportingService_1.LoginLinkNames.FORGOT_PASSCODE, forgotPasscodeUrl);
                            window.location.href = forgotPasscodeUrl;
                            _a.label = 3;
                        case 3: return [2 /*return*/];
                    }
                });
            }); };
            var extraSecurityOff = {
                onCheckboxChange: function (value) {
                    console.log('turnOfExtraSecurity ', account.asmIndex, value.payload, _this.state);
                    _this.mapExtraSecurityCheckBox.set(account.asmIndex, value.payload);
                    var found = null;
                    console.groupCollapsed('extraSecurityOff:onCheckboxChange filtered');
                    var passcodeAccountsListState = _this.state.passcodeAccountsList
                        .filter(function (passcodeAccount) {
                        if (passcodeAccount.selectedASMIndex === account.asmIndex) {
                            found = passcodeAccount;
                        }
                        // tslint:disable-next-line:max-line-length
                        console.log("passcodeAccount: " + passcodeAccount.selectedASMIndex + " <> account: " + account.asmIndex);
                        return (passcodeAccount.selectedASMIndex !== account.asmIndex);
                    });
                    console.groupEnd();
                    console.log('skipValidation = ' + value.payload + ' account.asmIndex= ' + account.asmIndex);
                    var detailList;
                    if (found) {
                        detailList = __assign(__assign({}, found), { extraSecurityOff: value.payload });
                    }
                    else {
                        detailList = {
                            selectedASMIndex: account.asmIndex,
                            accountType: account.accountType,
                            extraSecurityOff: value.payload,
                        };
                    }
                    console.log('detailList = ', detailList);
                    passcodeAccountsListState.push(detailList);
                    console.log('passcodeAccountListState = ', passcodeAccountsListState);
                    _this.setState({
                        passcodeAccountsList: passcodeAccountsListState,
                    });
                },
            };
            var skipPasscode = {
                onCheckboxChange: function (value) {
                    console.log('continueWithoutPasscode ', value.payload);
                    _this.skipPasscodeCheckBoxMap.set(account.asmIndex, value.payload);
                    /* uncheck the extrasecuirty checkbox if enabled*/
                    if (_this.mapExtraSecurityCheckBox.get(account.asmIndex)) {
                        _this.mapExtraSecurityCheckBox.set(account.asmIndex, false);
                    }
                    /* disable the extrasecuirty checkbox if enabled*/
                    var disableExtraSecurity = _this.state.disableExtraSecurity;
                    var disableTextFiled = _this.state.disableTextFiled;
                    disableTextFiled.set(account.asmIndex, value.payload);
                    if (value.payload) {
                        _this.passcodevalue2.set(account.asmIndex, '');
                        _this.errorMap.set(account.asmIndex, '');
                    }
                    var passcodeAccountsListState = _this.state.passcodeAccountsList;
                    if (value.payload) {
                        passcodeAccountsListState =
                            passcodeAccountsListState
                                .filter(function (passcodeAccount) {
                                return (passcodeAccount.selectedASMIndex !== account.asmIndex);
                            });
                        console.log('skipValidation = ' + value.payload + ' account.asmIndex= ' + account.asmIndex);
                        var detailList = {
                            selectedASMIndex: account.asmIndex,
                            accountType: account.accountType,
                            // passcode: '',
                            skipValidation: true,
                        };
                        passcodeAccountsListState.push(detailList);
                        console.log('detailList = ' + JSON.stringify(detailList));
                    }
                    _this.setState({
                        disableTextFiled: disableTextFiled, disableExtraSecurity: disableExtraSecurity,
                        passcodeAccountsList: passcodeAccountsListState, showModal: false,
                    });
                    console.log('passcodeAccountsListState 4 = ' + JSON.stringify(passcodeAccountsListState));
                    _this.enableContinueButton(_this.props.data.accountList);
                    /*    this.disableExtraSecurity.set(i, true);
                        this.disableTextFiled.set(i, true);
                    */
                },
            };
            if (true) {
                var passcodeLabel = account.smbCustomer ?
                    _this.PasscodeCmsData.passCode.businessPasscodeLabel : _this.PasscodeCmsData.passCode.passcodeLabel;
                return (React.createElement("div", { key: i },
                    React.createElement("div", { className: [
                            utilityStyles.marTXsLg,
                            utilityStyles.marTXsSm,
                            styles.signedInWith,
                        ].join(' ') },
                        "Enter your passcode for account number ",
                        account.maskedBan),
                    React.createElement("div", { className: [
                            utilityStyles.formRow,
                            utilityStyles.marTMdSm,
                        ].join(' ') },
                        React.createElement(TextField_1.default, { data: {
                                input: _this.passcodevalue2.get(account.asmIndex),
                                name: 'password',
                                labelText: passcodeLabel,
                            }, options: {
                                accessibility: passcodeLabel,
                                type: TextFieldProps_1.TextFieldType.PASSWORD,
                                error: _this.state.isPasscodeinValid,
                                errorText: _this.errorMap.get(account.asmIndex) ?
                                    _this.errorMap.get(account.asmIndex) : '',
                                disabled: (!_this.state.disableTextFiled.get(account.asmIndex))
                                    ? false : true,
                                tooltip: (React.createElement(Tooltip_1.default, { content: _this.PasscodeCmsData.passCode.passcodeToolTip, position: "top", style: { display: 'block', top: 0, margin: 1 }, boxWidth: 300, show: false, className: "mar-l-xxs" },
                                    React.createElement(IconSvg_1.default, { ariaHidden: false, ariaLabel: _this.PasscodeCmsData.passCode.passcodeToolTip, size: 24, colorClass: "color-ui-black", svgNodeStr: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path class=\"svg-base\" d=\"M8.5 1A7.5 7.5 0 1016 8.5 7.5 7.5 0 008.5 1zM9 12H8v-1h1zm.83-3.55l-.1.08C9.16 9 9 9.13 9 9.68V10H8v-.32a2.21 2.21 0 011.1-1.93l.11-.08a1.11 1.11 0 00.54-.9c0-.69-.72-.76-1-.76a2.18 2.18 0 00-1.45.63l-.7-.74A3.14 3.14 0 018.72 5a1.8 1.8 0 012 1.76 2.11 2.11 0 01-.89 1.69z\"/></svg>" }))),
                            }, events: passcodeEventsV2, id: "password", testId: loginPasscodeTestId + '_Password_TextField' }),
                        React.createElement("div", { className: [
                                utilityStyles.marTXxs,
                            ].join(' ') },
                            React.createElement(Link_1.default, { kind: "textPlain", className: appStyles.regPrimaryLinkMedium, onClick: linkForgotPasscodeEvent, testId: "Login_Passcode_Link_ForgotPassword" }, _this.PasscodeCmsData.passCode.forgotPasscodeLinkText))),
                    (_this.props.data.channel === 'services' || _this.props.data.channel === 'acctmgmt'
                        || (_this.state.currentAccountList != null
                            && _this.state.currentAccountList.length > 1)) &&
                        React.createElement("div", { className: [
                                utilityStyles.marTSm,
                                utilityStyles.padTXxxs,
                            ].join(' ') },
                            React.createElement(Checkbox_1.default, { data: {
                                    text: _this.PasscodeCmsData.passCode.continueWithoutCheckboxLabel,
                                    value: _this.skipPasscodeCheckBoxMap.get(account.asmIndex),
                                }, globalClasses: ['inline-flex'], events: skipPasscode, testId: "Login_Passcode_Checkbox_Continue_Without_Passcode" })),
                    (_this.extraSecurityFlag && account.accountType === ('MOBILE')) &&
                        React.createElement("div", { className: [
                                utilityStyles.marTSm,
                                utilityStyles.padTXxxs,
                            ].join(' ') },
                            React.createElement(Checkbox_1.default, { data: {
                                    text: _this.PasscodeCmsData.passCode.turnOffSecurityCheckboxLabel,
                                    value: _this.mapExtraSecurityCheckBox.get(account.asmIndex),
                                }, globalClasses: ['inline-flex'], options: {
                                    disabled: (_this.state.disableExtraSecurity.get(account.asmIndex)
                                        !== undefined
                                        && !_this.state.disableExtraSecurity.get(account.asmIndex))
                                        ? false : true,
                                }, events: extraSecurityOff, testId: "Login_Passcode_Checkbox_TurnOff_Extra_Security" }))));
            }
        });
        return (React.createElement("div", { className: [styles.loginPasscodeWrapper].join(' ') },
            React.createElement(GridRow_1.default, null,
                React.createElement(GridColumn_1.default, { options: { size: 12, className: 'no-pad', customOptions: '' } },
                    React.createElement("div", { className: [utilityStyles.formRow].join(' ') },
                        React.createElement(PageLevelHeading_1.default, { data: {
                                headingText: this.PasscodeCmsData.common.iconHeadingTitle,
                            }, options: {
                                type: PageLevelHeadingProps_1.PageLevelHeadingType.HEADING_WITH_ICON,
                            }, testId: loginPasscodeTestId + '_Header' })))),
            React.createElement(GridRow_1.default, null,
                React.createElement(GridColumn_1.default, { options: {
                        size: 7,
                        className: appStyles.innerPanelContainer + ' pad-none',
                        customOptions: '',
                    } },
                    this.state.errorMessage &&
                        React.createElement("div", { className: [
                                utilityStyles.marTXxs,
                                utilityStyles.padTXxxs,
                            ].join(' ') },
                            React.createElement(PageLevelMessage_1.default, { data: {
                                    type: PageLevelMessageProps_1.PageLevelMessageType.ERROR,
                                    messageText: this.state.errorMessage,
                                }, testId: loginPasscodeTestId + '_Error_Message' })),
                    this.props.data.hasAccountSelection &&
                        React.createElement("div", { className: [
                                utilityStyles.marTXxs,
                                utilityStyles.padTXxxs,
                            ].join(' ') },
                            React.createElement(Link_1.default, { kind: "textPlain", className: appStyles.regPrimaryAlternateLinkMedium, onClick: this.linkAccountSelectionEvent, testId: "Login_Passcode_Link_Select_Different_Account" }, this.PasscodeCmsData.passCode.selectDifferentAcctLinkText)),
                    React.createElement("div", null, listItems),
                    React.createElement("div", { className: [
                            utilityStyles.padTXxs,
                            utilityStyles.marTLgSm,
                            utilityStyles.marTLgMd,
                            utilityStyles.marTMdLg,
                        ].join(' ') },
                        React.createElement(Link_1.default, { kind: "textPlain", className: appStyles.regPrimaryAlternateLinkMedium, onClick: this.linkSecurityPasscodeEvent, testId: "Login_Passcode_Link_Learn_More" }, this.PasscodeCmsData.passCode.learnMoreLinkText)),
                    React.createElement("div", { className: [
                            utilityStyles.marTMdLg,
                        ].join(' ') },
                        React.createElement(CtaButtonGroup_1.default, { data: {
                                primaryBtnText: this.state.processing ?
                                    this.PasscodeCmsData.common.buttonProcessingCTA :
                                    this.PasscodeCmsData.passCode.passcodePanelContinueCTA,
                                primaryBtnTestId: 'Login_Passcode_Button_Continue',
                                secondaryBtnLinkText: this.PasscodeCmsData.passCode.passcodePanelCancelCTA,
                                secondaryBtnTestId: 'Login_Passcode_Button_Cancel',
                                disabledPrimaryBtn: this.state.disabledButton,
                                showSpinner: this.state.processing,
                            }, options: {
                                type: CtaButtonGroupProps_1.CtaButtonGroupType.BUTTON_REVERSE_RIGHT,
                            }, primaryBtnEvents: {
                                onClick: this.continueBtnEvents,
                            }, secondaryBtnLinkEvents: {
                                onClick: this.cancelBtnEvents,
                            } })),
                    this.state.showModal &&
                        React.createElement(SMBAccountModal_1.default, { data: {
                                wirelineModal: this.state.wirelineModal,
                            }, events: this.modalEvents })))));
    };
    PasscodeV2.passcodeSuccessEventName = 'passcodeSuccessEvent';
    return PasscodeV2;
}(React.Component));
exports.default = PasscodeV2;
//# sourceMappingURL=PasscodeV2.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/login-ui/components/panels/Passcode/PasscodeV2.js
// module id = 648
// module chunks = 8